import React from 'react';
import translate from '../../../i18n/translate';
import { Container, IconButton, Link } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useNavigate } from 'react-router-dom';
import "./DynamicIntercept.scss"
import Loader from '../Loader/Loader';

const DynamicIntercept = (props: any) => {
    const navigate = useNavigate();
    const { intercept_title, intercept_subtitle, intercept_text1, intercept_text2, intercept_text3, intercept_text4, intercept_text5, intercept_text6, intercept_text7, intercept_text8, intercept_dd_mmm_text, is_dd_mmm_text_bold, intercept_window_title, intercept_support_text, intercept_or_text, intercept_link_not_work, intercept_note, intercept_family_note, intercept_url, learnship_home_url, learnship_login_url, support_url, intercept_sso_text, intercept_time, intercept_date, intercept_on_text } = props.companyInterceptData;
    document.title = intercept_window_title ? "Halo - " + intercept_window_title : "Halo";
    const handleSkipClick = () => {
        props.setInterceptFalse();
        navigate("/");
      }

  return (
    <React.Fragment>
      {props.companyInterceptData ?
      <div className="intercepts">
          <Container>
            <div className="intercepts-container">
              <div className="intercepts-close">
                <IconButton aria-label="delete" color="primary" onClick={handleSkipClick} >
                  <CloseIcon className="close-icon"></CloseIcon>
                </IconButton>
              </div>
              <div className="intercepts-content">
                <h3 className="intercepts-content-title">{translate(intercept_title)}</h3>
                <div className="intercepts-content-info">
                  <div className="intercepts-content-info-img"><img src={window.location.origin + "/images/" + "Feature_Illustrations/Solo-learner.svg"} alt="flag" ></img></div>
                  <div className="intercepts-content-info-text">
                  {intercept_subtitle && <b><p>{translate(intercept_subtitle)}</p></b>}
                  <p>
                    {translate(intercept_text1)} {<b>{translate(intercept_sso_text)}</b>} {translate(intercept_text2)} {translate(intercept_text3)} {<b>{translate(intercept_time)}</b>} {translate(intercept_on_text)} {<b>{translate(intercept_date)}</b>}{", " }{translate(intercept_text4)}
                    <Link href={process.env.REACT_APP_SSO_LOGIN + intercept_url}><strong>{process.env.REACT_APP_SSO_LOGIN + intercept_url}</strong></Link>
                    {". "} {intercept_link_not_work && translate(intercept_link_not_work)}
                  </p>
                  <p>
                    {translate(intercept_text5)} {is_dd_mmm_text_bold ? <b>{translate(intercept_dd_mmm_text)}</b> : translate(intercept_dd_mmm_text)}{translate(intercept_text6)}
                    {learnship_home_url && <Link href={process.env[learnship_home_url]}>{process.env[learnship_home_url]}</Link>} {"or "} 
                    {learnship_login_url && <Link href={process.env[learnship_login_url]}>{process.env[learnship_login_url]}</Link>}
                    {". "}
                  </p>
                  
                  <p>
                    {translate(intercept_text7)}
                  </p>
                  <p>
                    {translate(intercept_text8)} {intercept_support_text && <b>{translate(intercept_support_text)}</b>} {intercept_support_text && intercept_or_text && translate(intercept_or_text)}
                    <Link href={process.env[support_url]}>{process.env[support_url]}</Link>{"."}
                  </p>
                  {intercept_note && <i><p>{translate(intercept_note)} {translate(intercept_family_note)}</p></i>}
                  </div>           
                </div>
              </div>
            </div>
          </Container>
      </div> : <Loader showLoader={true} />
      }
    </React.Fragment>
  )
}

export default DynamicIntercept